export default (iNumber: number, aEndings: string[]): string => {
  // aEndings - ['яблоко', 'яблока', 'яблок']
  let sEnding: string
  iNumber = iNumber % 100

  if (iNumber >= 11 && iNumber <= 19) {
    sEnding = aEndings[2]
  } else {
    const i: number = iNumber % 10
    switch (i) {
      case 1:
        sEnding = aEndings[0]
        break
      case 2:
      case 3:
      case 4:
        sEnding = aEndings[1]
        break
      default:
        sEnding = aEndings[2]
    }
  }

  return sEnding
}
